<template>
  <div id="system-publisher-policy-add">
    <ipub-model :title="params.id?'Edit Policy':'Add Policy'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="publisher-policy-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Policy Title">
          <ipub-input placeholder="Enter policy title here"
                      :disabled="params.type && params.type!=='CUSTOMIZE'"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="parentId"
                        label="Parent Policy">
          <ipub-select placeholder="Select Parent Policy"
                       :options="tree"
                       :tree="true"
                       optionKey="id"
                       :disabled="params.type && params.type!=='CUSTOMIZE'"
                       v-model="params.parentId" />
        </ipub-form-item>
        <ipub-form-item prop="content"
                        label="Content">
          <ipub-editor :height="400"
                       placeholder="Enter policy details here"
                       v-model="params.content" />
        </ipub-form-item>
        <ipub-form-item prop="comment"
                        label="Description">
          <ipub-input placeholder="Enter description here"
                      v-model="params.comment" />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button plain
                     type="primary"
                     :style="{minWidth: '150px'}"
                     @click="cancel">Cancel</ipub-button>
        <ipub-button type="primary"
                     :style="{minWidth: '150px'}"
                     @click="confirm">Submit</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pmenu from '../../../../api/pmenu'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    tree: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      params: {},
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    setParentId (id) {
      this.params.parentId = id
    },
    async getQuery (id) {
      this.params = await pmenu.query(id)
    },
    async confirm (val) {
      const flag = this.$refs['publisher-policy-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          code: this.params.type ? this.params.code : this.params.name.toLowerCase().replace(' & ', "_").replace(/\s/g, "_"),
          released: val
        })
        if (this.params.id) {
          await pmenu.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Publisher Policy has been Created!' })
        } else {
          await pmenu.add(data)
          this.$message.success({ title: 'Success', content: 'This Publisher Policy has been saved!' })
        }
        this.$emit('confirm', data)
      }
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Policy Title' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 100,
            message:
              'Policy title: Maxium 100 characters'
          },
        ],
        parentId: [
          {
            required: true,
            message:
              'Policy Belongs To' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        // content: [
        //   {
        //     required: true,
        //     message:
        //       'Content' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#system-banners-add {
  .upload-content {
    height: 180px;
    width: 280px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
